import FeedPagination from './FeedPagination';
import FeedPaginationContainer from './FeedPagination.container';

export default FeedPaginationContainer(FeedPagination);
